<template>
  <div :class="$style[classes]">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" v-loading="loading" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels">
            <template slot="before">
              <el-table-column label="提问主题">
                <template slot-scope="scope">
                  {{scope.row.topic}}
                </template>
              </el-table-column>
              <el-table-column label="提问用户" min-width="220">
                <template slot-scope="scope">
                  <template v-if="scope.row.questionerInfo">
                  {{scope.row.questionerInfo.fullName}}
                  <span class="customer-mobile">{{scope.row.questionerInfo.mobile}}</span>
                  </template>
                  <span>{{scope.row.questionerExtendInfo&&scope.row.questionerExtendInfo.memberLevelName}}</span>
                  <span>{{scope.row.questionerExtendInfo&&scope.row.questionerExtendInfo.city}}</span>
                </template>
              </el-table-column>
              <el-table-column label="产科医生" min-width="300">
                <template slot-scope="scope">
                  <template v-if="scope.row.answererInfo">
                  {{scope.row.answererInfo.name}}
                  <span class="customer-mobile">{{scope.row.answererInfo.mobile}}</span>
                  </template>
                  <span v-if="scope.row.qaHospitals&&scope.row.qaHospitals.length">
                    {{scope.row.qaHospitals[0].name}}
                  </span>
                  <span v-if="scope.row.answererInfo">
                    {{scope.row.answererInfo.position}}
                  </span>
                  <span v-if="scope.row.answererInfo&&scope.row.answererInfo.addressDetails">{{scope.row.answererInfo.addressDetails.provinceName+scope.row.answererInfo.addressDetails.cityName}}</span>
                </template>
              </el-table-column>
            </template>
            <template>
              <slot/>
            </template>
          </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-obs-department-table'

export default {
  name: 'pt-obs-department-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: 'total,sizes, prev, pager, next,jumper'
    },
    pageSizes: {
      type: Array,
      default: function () {
        return [10, 20, 30, 50, 200]
      }
    },
    pageSize: {
      type: Number,
      default: 20
    },
    loading: {
      type: Boolean,
      default: false
    },
    isOutside: {
      type: Boolean
    },
    tableData: {
      type: Array
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    showReTry () {
      this.$refs.table.showReTry()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style module lang="less">
@import "~less/var.less";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-obs-department-table{
  :global{
      span{
      margin-left: 5px;
      }
    .customer-mobile{
      color: @mainColor
    }
    .el-button{
      margin-left: 0;
      margin-right: 10px
    }
  }
}
</style>
